import AddElementAction from './addElementAction';

class AddClick extends AddElementAction {
  _getSchemaId() {
    return 'urn:shared:user:event:/data-platform/signals/click/v1';
  }

  _handleLegacy(input) {
    const type = 'click';
    const legacyPayload = this._transformLegacyPromo(type, input.element, input.promotion);
    if (this._isPromo(input)) {
      // Send to the legacy add_promotion handler with corresponding type
      this.schemaHelper.handleSchema(
        'add_promotion',
        type,
        'v2',
        legacyPayload,
        this.extras);
    } else {
      // Call the legacy generic add event handler
      this.schemaHelper.handleSchema(
        'add_event',
        undefined,
        'v2',
        legacyPayload,
        this.extras);
    }
  }
}

export default AddClick;
